import script from "./txList.vue?vue&type=script&setup=true&lang=ts"
export * from "./txList.vue?vue&type=script&setup=true&lang=ts"

import "./txList.vue?vue&type=style&index=0&id=e8c8ea58&lang=scss&scoped=true"

import exportComponent from "/home/circleci/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8c8ea58"]])

export default __exports__